import { persistTrackingData } from '../util';
import { initDataLayer } from '../util/initDataLayer';
import { isBrowser } from '../util/isBrowser';
export function pushClearShortlist(data) {
    var _a;
    if (!isBrowser())
        return;
    initDataLayer();
    const message = {
        event: 'clearWishlist',
        wishlist: {
            lastRemoved: (_a = data.clearShortlist) === null || _a === void 0 ? void 0 : _a.estabIds,
        },
    };
    window.dataLayer.push(message);
    persistTrackingData(message);
}
